<template>
  <div class="member-profile tongxin-layout">
    <h1 class="title-with-underline">家庭成員資料</h1>

    <div class="profile-card" v-if="memberData">
      <!-- <div class="profile-header">
        <h2 class="profile-name">{{ memberData.ptName }}</h2>
        <span class="profile-badge">
          {{ memberData.relationship }}
        </span>
      </div> -->

      <div class="profile-body">
        <div class="info-row">
          <span class="label">姓名</span>
          <span class="value">{{ memberData.ptName }}</span>
        </div>

        <div class="info-row">
          <span class="label">身分證字號</span>
          <span class="value">{{ memberData.ptIdno }}</span>
        </div>

        <div class="info-row">
          <span class="label">出生年月日</span>
          <span class="value">{{ formattedBirthday }}</span>
        </div>
      </div>

      <div class="profile-footer">
        <div class="reminder-green" v-if="isAuthorized">
          授權 {{ memberData.ptName }} 先生（或 xxx 女士）已授權您新增本項修改紀錄，並代替本人處理相關事務。
        </div>
        <div class="reminder-yellow" v-else>
          此成員尚未授權，待對方同意後即可代為預約。
        </div>
      </div>
    </div>

    <div style="padding-bottom: 96px"></div>
    <div class="fixed-footer-navigation">
      <button class="btn btn-secondary w-50" @click="goBack">
        返回
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TongxinFamilyMemberProfile',
  props: {
    memberId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      memberData: null,
    }
  },
  computed: {
    // 透過 route query 的 source 判斷是否為已授權親友
    isAuthorized() {
      return this.$route.query.source === 'auth'
    },

    formattedBirthday() {
      const birthday = this.memberData?.ptBirthday
      if (!birthday) {
        return '-'
      }

      // SAW API 格式："1990/5/15 上午 12:00:00"
      const datePart = birthday.split(' ')[0]
      if (datePart && datePart.includes('/')) {
        const parts = datePart.split('/')
        if (parts.length === 3) {
          return `${parts[0]} 年 ${parseInt(parts[1])} 月 ${parseInt(parts[2])} 日`
        }
      }

      // YYYY-MM-DD 格式
      const parts = birthday.split('-')
      if (parts.length === 3) {
        return `${parts[0]} 年 ${parseInt(parts[1])} 月 ${parseInt(parts[2])} 日`
      }

      return birthday
    },
  },
  created() {
    this.loadMemberData()
  },
  methods: {
    loadMemberData() {
      // 從 query 讀取成員資料
      const dataStr = this.$route.query.data
      if (dataStr) {
        try {
          this.memberData = JSON.parse(dataStr)
        } catch (error) {
          console.error('解析成員資料失敗:', error)
        }
      }

      // 如果沒有資料，嘗試從其他來源載入
      // TODO: 可以 call API 取得成員詳細資料
    },

    goBack() {
      this.$router.push({ name: 'TongxinFamilyList' })
    },
  },
}
</script>

<style lang="scss" scoped>
.member-profile {
  max-width: 600px;
  margin: 0 auto;
  padding: 20px;

  .profile-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    padding: 24px;
    margin-top: 40px;

    .profile-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 24px;
      padding-bottom: 16px;
      border-bottom: 2px solid #f0f0f0;

      .profile-name {
        font-size: 24px;
        font-weight: bold;
        color: #333;
        margin: 0;
      }

      .profile-badge {
        background: #207868;
        color: white;
        padding: 6px 16px;
        border-radius: 16px;
        font-size: 14px;
        font-weight: 600;
      }
    }

    .profile-body {
      margin-bottom: 24px;

      .info-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 0;
        border-bottom: 1px solid #f0f0f0;

        &:last-child {
          border-bottom: none;
        }

        .label {
          font-size: 16px;
          color: #666;
          font-weight: 500;
        }

        .value {
          font-size: 16px;
          color: #333;
          font-weight: 600;
        }
      }
    }

    .profile-footer {
      .reminder-green {
        background: #e8f5f3;
        border-left: 4px solid #207868;
        padding: 16px;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }

      .reminder-yellow {
        background: #fef3e8;
        border-left: 4px solid #f59e0b;
        padding: 16px;
        border-radius: 4px;
        font-size: 14px;
        color: #333;
        line-height: 1.6;
      }
    }
  }
}
</style>
